import { Box, Stack } from "@mui/material";
import BrandsSearchItemsCard from "./BrandsSearchItemsCard";



const BrandsSearchItems = () => {
  return (
    <>
      <Box>
      <Stack spacing={2}>
        <BrandsSearchItemsCard
          title="Bettom Sport UK"
          brandId="2319"
          value="547"
          clickOut="1,347"
          roi="51%"
          roiColor="warning"
          ftd="398"
          ftdPercentage="30%"
          ftdColor="error"
          qftd="396"
          qftdPercentage="29%"
          qftdColor="error"
          cpaIncome="$60,509"
          rsIncome="$42,711"
          totalIncome="$103,220"
          pv="$252"
          epc="$52"
          epcCpc="$38"
          runDate="01/01/2026"
          runRange="24/12/2025 - 01/01/2026"
          runBy="System"
          status="Success"
        />
         <BrandsSearchItemsCard
          title="LuckyMate Sport UK"
          brandId="2319"
          value="96"
          clickOut="100"
          roi="97%"
          roiColor="success"
          ftd="95"
          ftdPercentage="96%"
          ftdColor="success"
          qftd="89"
          qftdPercentage="88%"
          qftdColor="warning"
          cpaIncome="$60,509"
          rsIncome="$42,711"
          totalIncome="$103,220"
          pv="$252"
          epc="$52"
          epcCpc="$38"
          runDate="01/01/2026"
          runRange="24/12/2025 - 01/01/2026"
          runBy="Michael Lieberman"
          status="Failure"
        />
        <BrandsSearchItemsCard
          title="Bet MGM Sport UK "
          brandId="1567"
          value="887"
          clickOut="1,948"
          roi="29%"
          roiColor="error"
          ftd="654"
          ftdPercentage="79%"
          ftdColor="warning"
          qftd="12"
          qftdPercentage="7%"
          qftdColor="error"
          cpaIncome="$60,509"
          rsIncome="$42,711"
          totalIncome="$103,220"
          pv="$252"
          epc="$52"
          epcCpc="$38"
          runDate="01/01/2026"
          runRange="24/12/2025 - 01/01/2026"
          runBy="System"
          status="Failure"
        />
         
      </Stack>
    </Box>
    </>
  )
}

export default BrandsSearchItems